import { MAP_TYPES } from '@deck.gl/carto';
 
const HISTORICALHCCL_SOURCE_ID = 'historicalHCCLSource';
 
const source = {
  id: HISTORICALHCCL_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: 'historical_hccl_source',
}

export default source;